"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.setSchemas = void 0;
var json_schema_faker_1 = __importDefault(require("json-schema-faker"));
var SchemaCache = {};
var setSchemas = function (schemas) {
    SchemaCache = schemas;
};
exports.setSchemas = setSchemas;
function overrideTimestamps(data) {
    Object.keys(data).reduce(function (obj, key) {
        if (typeof key === 'string' && key.indexOf('.') > -1) {
            var walk = key.split('.');
            var last = walk.pop();
            var nested = walk.reduce(function (deep, prop) {
                if (!deep[prop]) {
                    deep[prop] = {};
                }
                return deep[prop];
            }, obj);
            nested[last] = obj[key];
            delete obj[key];
            return obj;
        }
        var aKey = key;
        var val = obj[aKey];
        var value = typeof val === 'object' && val !== null ? val : {};
        var _a = value, seconds = _a.seconds, nanoseconds = _a.nanoseconds;
        if (seconds && nanoseconds) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            obj[aKey] = new Date(seconds);
        }
        return obj;
    }, data);
    return data;
}
function generate(taraType, overridesOrLength, len) {
    var schema = SchemaCache[taraType];
    if (!schema) {
        throw new Error("Schema ".concat(taraType, " not found in ").concat(Object.keys(SchemaCache), "."));
    }
    if (typeof overridesOrLength !== 'number' && len === undefined) {
        return overrideTimestamps(Object.assign(json_schema_faker_1.default.generate(schema), overridesOrLength));
    }
    var _a = typeof overridesOrLength === 'number' ? [{}, overridesOrLength] : [overridesOrLength, len], obj = _a[0], length = _a[1];
    return new Array(length).fill(null).map(function () { return overrideTimestamps(Object.assign(json_schema_faker_1.default.generate(schema), obj)); });
}
exports.generate = generate;
